import { useModalContext } from '../../../context/Modal';
import { Icon } from '../../UI';

import { CopyTo } from './CopyTo';
import { DeleteAssetModal } from './DeleteAsset';

export const MultiSelected = ({
  assetsIds,
  isAllSelected,
  strategyId,
  handleAllCheck,
}: {
  assetsIds: string[];
  isAllSelected: boolean;
  strategyId: string;
  handleAllCheck(): void;
}) => {
  const { dispatch: dispatchModal, setElement } = useModalContext();

  const onCopy = () => {
    dispatchModal({
      className: 'h-full w-full overflow-y-scroll',
      element: <CopyTo strategyAssetIds={assetsIds} strategyId={strategyId} />,
      handleMerlinLogo: true,
      isFullScreenElement: true,
    });
  };

  const onDelete = () =>
    dispatchModal({
      element: (
        <DeleteAssetModal
          strategyAssetIds={assetsIds}
          strategyId={strategyId}
        />
      ),
      height: 'auto',
    });

  return (
    <>
      {(assetsIds.length > 0 || isAllSelected) && (
        <div
          className={`
            flex
            gap-4
            items-center
            bg-black
            dark:bg-grey-70
            sticky
            px-4
            w-min
            mx-auto
            rounded-xl
          `}
        >
          <div
            className="flex items-center mx-auto cursor-pointer"
            onClick={handleAllCheck}
          >
            <Icon
              svgName="check"
              color={isAllSelected ? 'white' : 'black'}
              className="h-3 w-3 mr-2"
            />
            <span
              className={`
                ${isAllSelected ? 'text-grey-50' : 'text-white'}
                text-sm
                whitespace-nowrap
              `}
            >
              All selected
            </span>
          </div>

          <span
            className={`
              mx-auto
              whitespace-nowrap
              text-white
              text-sm
              px-4
              border-l
              border-r
              border-grey-50
              py-1
              my-1
              cursor-pointer
            `}
            onClick={onCopy}
          >
            Copy selected to
          </span>

          <span
            className={`
              whitespace-nowrap
              text-white
              text-sm
              cursor-pointer
            `}
            onClick={onDelete}
          >
            Delete selected
          </span>
        </div>
      )}
    </>
  );
};
